import { KV } from 'yam-types'
import { ExprException } from './exception'
import exec from './exec'
import lexer from './lexer'
import { isParseErr, statement } from './parser'

// execExpr executes exprContent and returns a tuple
// The first element of the tuple is the value of the expression
// And the second element is the tail content
export default function execExpr(
  exprContent: string,
  data: KV,
  missingKeyCb: (key: string) => void,
  renderHelpers: { [helperName: string]: (...args: unknown[]) => unknown }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): [any, string] {
  try {
    const expr = statement(lexer(exprContent))
    if (isParseErr(expr)) {
      if (typeof expr.reason === 'string') {
        throw new Error(expr.reason)
      }
      const token = expr.reason.token
      throw new ExprException(token.codePos, `Unexpected token ${token.kind}(${token.value})`)
    }

    return [
      exec(expr.value, data, missingKeyCb, renderHelpers),
      // tail content
      exprContent.substring(expr.tailLexer.position)
    ]
  } catch (e) {
    if (e instanceof ExprException) {
      throw new Error(
        `\n${exprContent}\n`
        + ' '.repeat(e.position[0])
        + '^'.repeat(e.position[1] - e.position[0])
        + '\n'
        + e.reason
      )
    }
    throw e
  }
}
